import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { RiBarChart2Line, RiFileList2Line, RiPencilLine } from 'react-icons/ri';
import { useSelector } from 'react-redux';

import PathTools from './01_PathTools';
import FenceTools from './02_FenceTools';
import Chart from './97_Chart';
import Guide from './98_Guide';
import MapTool from './99_MapTool';
import styles from './index.module.scss';

import Bar from '@/components/ui/Bar';
import SlidingPanel from '@/components/ui/SlidingPanel';

const cx = classNames.bind(styles);

const Sidebar = () => {
  const enabled = useSelector((state) => state.editor.enabled);
  const [isShowDrawingTool, setShowDrawingTool] = useState(true);
  const [isShowChart, setShowChart] = useState(false);
  const [isShowGuide, setShowGuide] = useState(false);

  useUpdateEffect(() => {
    setShowDrawingTool(enabled);
  }, [enabled]);

  const toggleDrawingTool = () => {
    setShowDrawingTool(!isShowDrawingTool);
  };

  const toggleChart = () => {
    setShowChart(!isShowChart);
  };

  const toggleGuide = () => {
    setShowGuide(!isShowGuide);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('groups')}>
        <Bar size={24} horizontal />
        <div className={cx('group')}>
          <div
            className={cx(['button', { active: isShowDrawingTool, disabled: !enabled }])}
            onClick={toggleDrawingTool}>
            <RiPencilLine size={20} color={enabled ? 'white' : 'gray'} />
          </div>
        </div>
      </div>
      <div className={cx('groups')}>
        <div className={cx('group')}>
          <div className={cx(['button', { active: isShowChart }])} onClick={toggleChart}>
            <RiBarChart2Line size={20} color="white" />
          </div>
          <div className={cx(['button', { active: isShowGuide }])} onClick={toggleGuide}>
            <RiFileList2Line size={20} color="white" />
          </div>
        </div>
        <Bar size={24} horizontal />
        <MapTool />
        <Bar size={24} horizontal />
      </div>

      {/* Panels */}
      <SlidingPanel active={isShowDrawingTool} origin="left">
        <PathTools />
        <FenceTools />
      </SlidingPanel>
      <SlidingPanel active={isShowChart} origin="bottom" className={cx('chart')}>
        <Chart />
      </SlidingPanel>
      <SlidingPanel active={isShowGuide} origin="bottom" style={{ right: 48 }}>
        <Guide />
      </SlidingPanel>
    </div>
  );
};

export default Sidebar;
